/** sessionStorage key for GET /grader/study/index response row (`data[0]`). */
export const GRADER_STUDY_INDEX_SESSION_KEY = 'graderStudyIndex';
